import { Geolocation } from '@capacitor/geolocation';
//import { Plugins } from '@capacitor/core';

//const { Geolocation } = Plugins;
// get the users current position
export type GeoType = { lat: any, lon: any };

export class Geo {
    //static getLocation: any;

    public async getLocation():Promise<GeoType> {

        try {
            const position = await Geolocation.getCurrentPosition({enableHighAccuracy: true, timeout: 20000, maximumAge: 0});

            // grab latitude & longitude
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            
            return {lat:latitude,lon:longitude};
        }
        catch (e) {
            console.log("GeoLocation Error")
            /*
            return new Promise((_, reject) =>
                        reject(new Error('locationNotPermitted'))
                   );
                   */
            return {lat:"0",lon:"0"};
        }
    }

};

export default Geo;

